import { Languages } from '../languages'

export enum MaskinportenMessages {
  GETTING_STARTED_PARAGRAPH_1 = 'GETTING_STARTED_PARAGRAPH_1',
  GETTING_STARTED_PARAGRAPH_2 = 'GETTING_STARTED_PARAGRAPH_2',
  GETTING_STARTED_PARAGRAPH_3 = 'GETTING_STARTED_PARAGRAPH_3',
  GETTING_STARTED_SECTION_1_TITLE = 'GETTING_STARTED_SECTION_1_TITLE',
  GETTING_STARTED_SECTION_1_DESC = 'GETTING_STARTED_SECTION_1_DESC',
  GETTING_STARTED_SECTION_2_TITLE = 'GETTING_STARTED_SECTION_2_TITLE',
  GETTING_STARTED_SECTION_2_DESC_1 = 'GETTING_STARTED_SECTION_2_DESC_1',
  GETTING_STARTED_SECTION_2_LI_1 = 'GETTING_STARTED_SECTION_2_LI_1',
  GETTING_STARTED_SECTION_2_LI_2 = 'GETTING_STARTED_SECTION_2_LI_2',
  GETTING_STARTED_SECTION_2_LI_3 = 'GETTING_STARTED_SECTION_2_LI_3',
  GETTING_STARTED_SECTION_2_LI_4 = 'GETTING_STARTED_SECTION_2_LI_4',
  GETTING_STARTED_SECTION_2_LI_5 = 'GETTING_STARTED_SECTION_2_LI_5',
  GETTING_STARTED_SECTION_2_DESC_2 = 'GETTING_STARTED_SECTION_2_DESC_2',
  GETTING_STARTED_SECTION_3_TITLE = 'GETTING_STARTED_SECTION_3_TITLE',
  GETTING_STARTED_SECTION_3_DESC = 'GETTING_STARTED_SECTION_3_DESC',
  CREATE_CLIENT_SECTION_1_TITLE = 'CREATE_CLIENT_SECTION_1_TITLE',
  CREATE_CLIENT_SECTION_1_LI_1 = 'CREATE_CLIENT_SECTION_1_LI_1',
  CREATE_CLIENT_SECTION_1_LI_2 = 'CREATE_CLIENT_SECTION_1_LI_2',
  CREATE_CLIENT_SECTION_1_LI_3 = 'CREATE_CLIENT_SECTION_1_LI_3',
  CREATE_CLIENT_SECTION_1_LI_4 = 'CREATE_CLIENT_SECTION_1_LI_4',
  CREATE_CLIENT_SECTION_1_LI_5 = 'CREATE_CLIENT_SECTION_1_LI_5',
  CREATE_CLIENT_SECTION_1_LI_6 = 'CREATE_CLIENT_SECTION_1_LI_6',
  CREATE_CLIENT_SECTION_1_LI_7 = 'CREATE_CLIENT_SECTION_1_LI_7',
  CREATE_CLIENT_SECTION_1_LI_8 = 'CREATE_CLIENT_SECTION_1_LI_8',
  CREATE_CLIENT_SECTION_1_LI_9 = 'CREATE_CLIENT_SECTION_1_LI_9',
  CREATE_CLIENT_SECTION_1_LI_10 = 'CREATE_CLIENT_SECTION_1_LI_10',
  CREATE_CLIENT_SECTION_1_LI_11 = 'CREATE_CLIENT_SECTION_1_LI_11',
  CREATE_CLIENT_SECTION_1_LI_12 = 'CREATE_CLIENT_SECTION_1_LI_12',
  CREATE_CLIENT_SECTION_2_TITLE = 'CREATE_CLIENT_SECTION_2_TITLE',
  CREATE_CLIENT_SECTION_2_DESC = 'CREATE_CLIENT_SECTION_2_DESC',
  CREATE_CLIENT_SECTION_2_LI_1 = 'CREATE_CLIENT_SECTION_2_LI_1',
  CREATE_CLIENT_SECTION_2_LI_2 = 'CREATE_CLIENT_SECTION_2_LI_2',
  CREATE_CLIENT_SECTION_2_LI_3 = 'CREATE_CLIENT_SECTION_2_LI_3',
  CREATE_CLIENT_SECTION_2_LI_4 = 'CREATE_CLIENT_SECTION_2_LI_4',
  SCOPES_PARAGRAPH_1_PART_1 = 'SCOPES_PARAGRAPH_1_PART_1',
  SCOPES_PARAGRAPH_1_PART_2 = 'SCOPES_PARAGRAPH_1_PART_2',
  SCOPES_PARAGRAPH_2_PART_1 = 'SCOPES_PARAGRAPH_2_PART_1',
  SCOPES_PARAGRAPH_1_LI_1 = 'SCOPES_PARAGRAPH_1_LI_1',
  SCOPES_PARAGRAPH_1_LI_2 = 'SCOPES_PARAGRAPH_1_LI_2',
  SCOPES_PARAGRAPH_1_LI_3 = 'SCOPES_PARAGRAPH_1_LI_3',
  SCOPES_PARAGRAPH_2_TITLE = 'SCOPES_PARAGRAPH_2_TITLE',
  SCOPES_PARAGRAPH_2_DESC = 'SCOPES_PARAGRAPH_2_DESC',
  SCOPES_PARAGRAPH_2_LI_1 = 'SCOPES_PARAGRAPH_2_LI_1',
  SCOPES_PARAGRAPH_2_LI_2 = 'SCOPES_PARAGRAPH_2_LI_2',
  SCOPES_PARAGRAPH_2_LI_3 = 'SCOPES_PARAGRAPH_2_LI_3',
  SCOPES_PARAGRAPH_2_LI_4 = 'SCOPES_PARAGRAPH_2_LI_4',
  SCOPES_PARAGRAPH_2_LI_5 = 'SCOPES_PARAGRAPH_2_LI_5',
  SCOPES_PARAGRAPH_2_LI_6 = 'SCOPES_PARAGRAPH_2_LI_6',
  SCOPES_PARAGRAPH_2_LI_7 = 'SCOPES_PARAGRAPH_2_LI_7',
  SCOPES_PARAGRAPH_2_LI_8 = 'SCOPES_PARAGRAPH_2_LI_8',
  SCOPES_PARAGRAPH_2_LI_9 = 'SCOPES_PARAGRAPH_2_LI_9'
}

export type IncludedMaskinportenMessages = {
  [P in MaskinportenMessages]: {
    [P in Languages]: string
  }
}

export const translatedMaskinportenMessages: IncludedMaskinportenMessages = {
  [MaskinportenMessages.GETTING_STARTED_PARAGRAPH_1]: {
    en: "Elhub uses Maskinporten as an authentication provider for machine-to-machine interfaces. Maskinporten is one of Digdir's joint solutions and ensures secure authentication and access control for data exchange between businesses. The solution guarantees the identity between businesses and makes it possible to connect systems and develop new services in an efficient way. Read more about the Maskinporten <link1>here</link1>."
  },

  [MaskinportenMessages.GETTING_STARTED_PARAGRAPH_2]: {
    en: 'APIs and scopes that are marked as Protected or named "_restricted" will only be available to parties that have entered data sharing agreements with Elhub (or are existing Elhub users bound by the Elhub user agreement) and have a legal basis for handling the restricted data. Parties that does not have a data sharing agreement may only use the available open APIs, which does not require integration with Maskinporten.'
  },

  [MaskinportenMessages.GETTING_STARTED_PARAGRAPH_3]: {
    en: 'To get started with testing, some preparations must be made before hand:'
  },
  [MaskinportenMessages.GETTING_STARTED_SECTION_1_TITLE]: {
    en: '1. Contact the Norwegian Digitalisation Agency to gain access to Maskinporten'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_1_DESC]: {
    en: 'Order access to Maskinporten via <link1>Digdir\'s Samarbeidsportalen.</link1> Please note that the person with the role "hovedadministrator" is needed for this first step, and this role is held by CEO and chairman by default.'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_TITLE]: {
    en: '2. Create a user in Samarbeidsportalen'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_DESC_1]: {
    en: 'When the agreement with Digdir has been established and access is in place in Altinn, you can log on to Samarbeidsportalen. If it is the first time you as a consumer log in to Samarbeidsportalen, <link1>you must create a user in Samarbeidsportalen.</link1>'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_LI_1]: {
    en: 'Go to <link1>https://samarbeid.digdir.no</link1>'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_LI_2]: {
    en: "Press 'Logg inn' in the top right corner."
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_LI_3]: {
    en: "Click 'Registrer deg' in the login window"
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_LI_4]: {
    en: 'Register as a user with your work email address'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_LI_5]: {
    en: 'Confirm the user by clicking on the link sent to the email. (NB! Check your junk mail if the email does not appear).'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_2_DESC_2]: {
    en: 'Please note that Digdir provides dedicated <link1>troubleshooting pages</link1> for scenarios where no token is generated. If you still have problems, please contact Servicedesk <link2>servicedesk@digdir.no.</link2>'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_3_TITLE]: {
    en: '3. Business certificates for test and production environment'
  },

  [MaskinportenMessages.GETTING_STARTED_SECTION_3_DESC]: {
    en: 'You must have a business certificate from Commfides or Buypass. Test certificate for test and normal for production. Remember to register a business certificate with the same organization number that you want to use at the Maskinporten and any services at Elhub.'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_TITLE]: {
    en: '1. Integration with Maskinporten '
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_1]: {
    en: 'If you want to create integration to Elhub APIs in Maskinporten, contact us at <link1>post@elhub.no</link1>, we will assign you the respective scope before proceeding further.'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_2]: {
    en: 'Go to <link1>https://samarbeid.digdir.no/</link1> and sign in.'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_3]: {
    en: "Select 'Integrasjoner -> Selvbetjening'. Use 'Test/Ver 2'  for test and 'Produksjon' for Production. It is advisable to configure with test environment before creating prod intregrations."
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_4]: {
    en: "Click 'Integrasjoner' under Test/Ver2 section"
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_5]: {
    en: "Click 'Ny integrasjon'"
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_6]: {
    en: "Set 'Difi-tjeneste' as Maskinporten."
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_7]: {
    en: 'Add scopes: elhub:balancesupplier / elhub:gridowner / elhub:publicstakeholder / elhub:thirdparty / elhub:enduser (If this does not appear, we have not received the correct org-no from you, send it <link1>post@elhub.no</link1>)'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_8]: {
    en: "Enter 'Navn på integrasjonen' and 'Beskrivelse'"
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_9]: {
    en: 'Select grant_types: urn:ietf:params:oauth:grant-type:jwt-bearer'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_10]: {
    en: 'Select token_endpoint_auth_method: private_key_jwt'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_11]: {
    en: "Set 'Access token levetid (sekunder)'. Recommended value is 60 secs"
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_1_LI_12]: {
    en: 'Save -> Then you get the client_id.'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_2_TITLE]: {
    en: '2. Testing Elhub APIs with token from Maskinporten'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_2_DESC]: {
    en: 'In general, the following is done:'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_2_LI_1]: {
    en: "First make a call to Maskinporten to get a token that can be used against the Elhub APIs. The procedure is described on <link1>Difi's site for how to use the machine port as a consumer.</link1>"
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_2_LI_2]: {
    en: 'For more info on how to generate the access token visit <link1>the github page for the token generator.</link1>'
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_2_LI_3]: {
    en: "The token is attached to the call to the API in the Authorization header. The token is attached like this: <br/> <strong> 'Authorization: Bearer {token}' </strong> <br/> For the concrete api resources, see calls <link1>here</link1>"
  },

  [MaskinportenMessages.CREATE_CLIENT_SECTION_2_LI_4]: {
    en: 'If everything is OK, data is returned according to the request.'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_1_PART_1]: {
    en: 'Scope indicates what resources the user is allowed to access and is a mechanism to let an application request limited access to data. In Maskinporten terminology, it is equivalent to a distinct API access.'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_1_PART_2]: {
    en: 'As an API provider, we will: '
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_1_LI_1]: {
    en: "Determine the information that the applications are able to access on a user's behalf."
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_1_LI_2]: {
    en: 'Define these access levels as custom scopes.'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_1_LI_3]: {
    en: 'Grant access to the users (organizations / personal access) for our defined scopes.'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_PART_1]: {
    en: 'As of today, we can only set up Maskinporten access for already registered entities in Elhub—not for end-users or other stakeholders. Scopes can only be provided to market party actors and service providers having an Elhub agreement, and only for metering values for the entire portfolio.'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_TITLE]: {
    en: 'Available scopes'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_DESC]: {
    en: 'We define scopes based on the party types currently present in Elhub:'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_1]: {
    en: 'elhub:balancesupplier'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_2]: {
    en: 'elhub:gridowner'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_3]: {
    en: 'elhub:thirdparty'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_4]: {
    en: 'elhub:publicstakeholder'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_5]: {
    en: 'elhub:enduser - This scope is not part of the market party type list. It is relevant for private users /  organizations that are not market parties.'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_6]: {
    en: 'elhub:serviceprovider'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_7]: {
    en: 'elhub:balanceresponsible'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_8]: {
    en: 'elhub:balancesupplieroflosses'
  },

  [MaskinportenMessages.SCOPES_PARAGRAPH_2_LI_9]: {
    en: 'elhub:balancesupplieroflastresort'
  }
}
